import * as types from '../mutation-types/editor-style-manager'

const namespaced = true
export const namespace = 'EditorStyleManager'

// state
const state = {
    allSelectors: [],

    allComposedSelectors: [],
    allComposedSelectorsFlat: [],
    unusedSelectors: [],
    
    openSelectorIds: [],

    selectorsComponents: {},
    selectorsOtherContents: {},

    selectorState: '',

    selectedComponent: null,
    selectedComponentSelectors: [],
    selectedComponentSelectorsWhitelist: [],
    selectedComponentIdSelector: null,
    selectedComponentInlineStyle: null,
}

// mutations
const updateUnusedSelectors = (s) => {
    const unusedSelectors = []

    s.allComposedSelectorsFlat.forEach(selector => {
        if (!s.selectorsComponents[selector.name]?.length && !s.selectorsOtherContents[selector.name]?.length) {
            unusedSelectors.push(selector)
        }
    })

    s.unusedSelectors = unusedSelectors
}

const mutations = {
    [types.SET_ALL_SELECTORS](s, { allSelectors, allComposedSelectors, allComposedSelectorsFlat }) {
        s.allSelectors = allSelectors
        s.allComposedSelectors = allComposedSelectors
        s.allComposedSelectorsFlat = allComposedSelectorsFlat
        updateUnusedSelectors(s)
    },

    [types.OPEN_SELECTOR](s, id) {
        if (!s.openSelectorIds.includes(id)) {
            s.openSelectorIds = [
                ...s.openSelectorIds,
                id,
            ]
        }
    },
    [types.CLOSE_SELECTOR](s, id) {
        const idx = s.openSelectorIds.indexOf(id)
        if (idx >= 0) {
            const selectorIds = [...s.openSelectorIds]
            selectorIds.splice(idx, 1)
            s.openSelectorIds = selectorIds
        }
    },

    [types.ADD_COMPONENT_TO_SELECTORS](s, {component, selectorNames}) {
        selectorNames.forEach(sn => {
            if (!s.selectorsComponents[sn]) {
                s.selectorsComponents[sn] = []
            }
            const idx = s.selectorsComponents[sn].findIndex(c => c.id == component.id)
            if (idx >= 0) {
                s.selectorsComponents[sn][idx] = component
                s.selectorsComponents = {...s.selectorsComponents}
            }
            else {
                s.selectorsComponents[sn].push(component)
            }
        })
        updateUnusedSelectors(s)
    },
    [types.REMOVE_COMPONENT_FROM_SELECTORS](s, {component}) {
        Object.keys(s.selectorsComponents).forEach(sn => {
            const idx = s.selectorsComponents[sn].findIndex(c => c.id == component.id)
            if (idx >= 0) {
                s.selectorsComponents[sn].splice(idx, 1)
            }
        })
        updateUnusedSelectors(s)
    },
    [types.SET_SELECTORS_OTHER_CONTENTS](s, {selectorsOtherContents}) {
        s.selectorsOtherContents = selectorsOtherContents
        updateUnusedSelectors(s)
    },

    [types.SET_SELECTOR_STATE](s, selectorState) {
        s.selectorState = selectorState
    },

    [types.SET_SELECTED_COMPONENT_SELECTORS](s, { selectedComponentSelectors, selectedComponentSelectorsWhitelist, selectedComponentIdSelector, selectedComponentInlineStyle }) {
        s.selectedComponentSelectors = selectedComponentSelectors || []
        s.selectedComponentSelectorsWhitelist = selectedComponentSelectorsWhitelist || []
        s.selectedComponentIdSelector = selectedComponentIdSelector || null
        s.selectedComponentInlineStyle = selectedComponentInlineStyle || null
    },
}

// actions
const actions = {
    setAllSelectors({commit}, payload) {
        commit(types.SET_ALL_SELECTORS, payload)
    },

    openSelector({commit}, payload) {
        commit(types.OPEN_SELECTOR, payload)
    },
    closeSelector({commit}, payload) {
        commit(types.CLOSE_SELECTOR, payload)
    },

    addComponentToSelectors({commit}, payload) {
        commit(types.ADD_COMPONENT_TO_SELECTORS, payload)
    },
    removeComponentFromSelectors({commit}, payload) {
        commit(types.REMOVE_COMPONENT_FROM_SELECTORS, payload)
    },
    setSelectorsOtherContents({commit}, payload) {
        commit(types.SET_SELECTORS_OTHER_CONTENTS, payload)
    },

    setSelectorState({commit}, payload) {
        commit(types.SET_SELECTOR_STATE, payload)
    },

    setSelectedComponentSelectors({commit}, payload) {
        commit(types.SET_SELECTED_COMPONENT_SELECTORS, payload || {})
    },
}

// getters
const getters = {
    allSelectors: s => {
        return s.allSelectors
    },
    publicSelectors: s => {
        return s.allSelectors.filter(i => !i.private)
    },
    allComposedSelectors: s => {
        return s.allComposedSelectors
    },
    unusedSelectors: s => {
        return s.unusedSelectors
    },

    openSelectorIds: s => {
        return s.openSelectorIds
    },

    selectorsComponents: s => {
        return s.selectorsComponents
    },
    selectorsOtherContents: s => {
        return s.selectorsOtherContents
    },
    
    selectorState: s => {
        return s.selectorState
    },

    selectedComponentPublicSelectors: s => {
        return s.selectedComponentSelectors.filter(i => !i.private)
    },
    selectedComponentPublicSelectorsWhitelist: s => {
        return s.selectedComponentSelectorsWhitelist.filter(i => !i.private)
    },
    selectedComponentIdSelector: s => {
        return s.selectedComponentIdSelector
    },
    selectedComponentInlineStyle: s => {
        return s.selectedComponentInlineStyle
    },
}

export default {namespaced, namespace, state, mutations, actions, getters}
